import { inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AnalyticsService } from './analytics.service';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AnalyticsInterceptor  {
  private _router = inject(Router);
  private _analyticsService = inject(AnalyticsService);

  constructor() {
    this._router.events.pipe(
      filter(navigationStart => navigationStart instanceof NavigationStart)
    ).subscribe((navigationStart: NavigationStart) => {
      this._analyticsService.addCounter(navigationStart.url);
    });
  }
}
